<template>
  <div class="content-wrapper">
    <vs-row class="my-4">
      <vs-col vs-lg="8" vs-sm="12">
        <vs-button
          :to="`/conferences/speakers/add` + suffixParams"
          color="primary"
          type="filled"
          >Add New</vs-button
        >
        <!--
        <vs-button
          @click="openFilter()"
          color="primary"
          type="filled"
          class="ml-3"
          >Filter</vs-button
        >
        -->
      </vs-col>
      <vs-col vs-lg="4" vs-sm="12">
        <div style="float: right">
          <vs-input
            id="search"
            class="inputx"
            placeholder="Search..."
            v-model="search"
            v-on:input="debounceInput"
          />
        </div>
      </vs-col>
    </vs-row>

    <vx-card>
      <b-table
        ref="table"
        style="min-height: 600px"
        striped
        hover
        fixed
        responsive
        show-empty
        sort-icon-left
        :selectable="true"
        :select-mode="`multi`"
        :busy.sync="isBusy"
        :items="dataProvider"
        :fields="columns"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :filterIncludedFields="filterOn"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
      >
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2" style="height: 600px">
            <b-spinner class="align-middle"></b-spinner>
            <div class="mt-3">
              <strong>Loading...</strong>
            </div>
          </div>
        </template>

        <template v-slot:cell(publish_status)="data">
          <vs-switch
            v-model="data.item.publish_status"
            icon-pack="feather"
            vs-icon="icon-check"
            @change="onStatusChanged(data.item)"
          />
        </template>
        <template v-slot:cell(listing_status)="data">
          <vs-switch
            v-model="data.item.listing_status"
            icon-pack="feather"
            vs-icon="icon-check"
            @change="onStatusChanged(data.item)"
          />
        </template>

        <template v-slot:cell(featured_status)="data">
          <vs-switch
            v-model="data.item.featured_status"
            icon-pack="feather"
            vs-icon="icon-star"
            @change="onStatusChanged(data.item)"
          />
        </template>

        <template v-slot:cell(fullname)="data">
          <div style="width: 250px">
            <img :src="data.item.speaker_profile_img" class="inline-img" />
            <strong>{{ data.item.fullname }}</strong>
          </div>
        </template>

        <template v-slot:cell(action)="data">
          <vs-button @click="open(data.item)" color="primary" type="flat"
            >View</vs-button
          >
        </template>
      </b-table>
      <div class="mt-3 text-center">
        <vs-pagination
          :total="Math.ceil(totalRows / 30)"
          v-model="currentPage"
          prev-icon="arrow_back"
          next-icon="arrow_forward"
        ></vs-pagination>

        <div class="mt-3">{{ from }} to {{ to }} of {{ totalRows }} items</div>
      </div>
    </vx-card>

    <filter-modal :list="filterList" @close="onFilterModalClose"></filter-modal>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Service from "@/services";

import FilterModal from "@/components/soldoutt/FilterModal.vue";

export default {
  components: {
    FilterModal,
  },
  data: () => ({
    suffixParams: "",
    columns: [
      { label: "ID", key: "speaker_id", sortable: false },
      { label: "Publish Status", key: "publish_status", sortable: false },
      { label: "Listing Status", key: "listing_status", sortable: false },
      { label: "Featured Status", key: "featured_status", sortable: false },
      {
        label: "Speaker Name",
        key: "fullname",
        sortable: false,
        tdClass: "width-450",
      },
      {
        label: "Tagline",
        key: "speaker_tagline",
        sortable: false,
        tdClass: "width-300",
      },
      {
        label: "Weight",
        key: "weight",
        sortable: false,
        tdClass: "width-300",
      },
      { label: "", key: "action", tdClass: "width-300", sortable: false },
    ],
    search: "",
    filter: "",
    sortBy: "",
    sortDesc: false,
    sortDirection: "asc",
    from: 1,
    to: 0,
    isBusy: false,
    currentPage: 1,
    perPage: 30,
    totalRows: 0,
    selected: [],
    filterOn: [],
    pageOptions: [2, 5, 10, 15, 30, 50],
    filterList: [],
  }),
  computed: {
    ...mapState({
      s: (state) => {
        return state.Utility.s;
      },
      e: (state) => {
        return state.Utility.e;
      },
    }),
  },
  created() {
    setTimeout(() => {
      this.suffixParams = "?s=" + this.s + "&e=" + this.e;
    }, 1200);
  },
  methods: {
    debounceInput: _.debounce(function (e) {
      this.filter = e;
      this.search = e;
    }, 500),
    checkSearchStr: _.debounce(function (val) {
      this.filter = val;
      this.$refs.table.refresh();
    }, 500),
    dataProvider(ctx, callback) {
      setTimeout(() => {
        this.isBusy = true;
        let data = {
          e: this.e,
        };

        let params = Object.keys(data)
          .map((key) => key + "=" + data[key])
          .join("&");

        params =
          params +
          "&" +
          Object.keys(ctx)
            .map((key) => key + "=" + ctx[key])
            .join("&");

        Service.Speaker.gets(params)
          .then((res) => {
            this.isBusy = false;
            this.totalRows = res.data.total;
            this.from = res.data.from;
            this.to = res.data.to;
            this.data = res.data.rows.map((item) => {
              return {
                ...item,
                fullname: item.speaker_firstname + " " + item.speaker_lastname,
              };
            });

            callback(this.data);
          })
          .catch((error) => {
            console.log(error);
            // Here we could override the busy state, setting isBusy to false
            // this.isBusy = false
            // Returning an empty array, allows table to correctly handle
            // internal busy state in case of error
            //return [];
            callback([]);
          });
        return null;
      }, 500);
    },
    open(item) {
      this.suffixParams =
        "?s=" + this.$route.query.s + "&e=" + this.$route.query.e;
      window.location.href =
        "/conferences/speakers/" +
        item.speaker_id +
        "/view" +
        this.suffixParams;
    },
    openFilter() {
      this.$bvModal.show("filter-modal");
    },
    onFilterModalClose() {
      this.$bvModal.hide("filter-modal");
    },
    onStatusChanged: _.debounce(function (e) {
      let data = {
        e: this.e,
        speaker_id: e.speaker_id,
        publish_status: e.publish_status,
        listing_status: e.listing_status,
        featured_status: e.featured_status,
      };

      this.$vs.loading();
      Service.Speaker.update(data).then((res) => {
        if (res.success) {
          this.$vs.notify({
            title: "Success",
            text: "Update complete.",
            color: "success",
          });
        }

        this.$vs.loading.close();
      });
    }, 500),
    /*
    duplicate(item) {
      this.$router.push("/conferences/speakers/add?clone=" + item.e);
    },
    */
  },
};
</script>